<template>
    <rkm-modal
        :loading="loading"
        ref="Modal"
        :title="`Ocupações - ${item.descricao}`"
    >
        <template v-if="index != null && item">

            <rkm-form
                ref="FormPermissaoOcupacao"
                show-legend
            >
                <rkm-row class="flex-nowrap">

                    <rkm-col class="flex-grow-1">

                        <rkm-form-input-autocomplete
                            :repository="repositories.ocupacao"
                            :request-query-string-params="autocompleteQueryStringParams.ocupacao"
                            :search-fields="autocompleteFields.ocupacao"
                            :validations="validations.ocupacao"
                            label="Ocupação"
                            uppercase
                            text-field="descricao"
                            v-model="model.ocupacao"
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-0 text-nowrap">

                        <rkm-button
                            :label="false"
                            color="primary"
                            @click="$refs.FormPermissaoOcupacao.validate(add)"
                        >
                            Incluir
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </template>

        <rkm-table
            :items="ocupacoes"
            :fields="fields"
            ref="Table"
        >
            <template v-slot:cell(actions)="{ index }">

                <rkm-button
                    @click="handleDestroy(index)"
                    color="danger"
                    title="Excluir"
                    small
                >
                    <rkm-icon icon="trash"/>
                </rkm-button>
            </template>
        </rkm-table>

        <template #footer>

            <rkm-button
                :disabled="!!loading"
                @click="handleCancel"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>

// Vuex
import { mapGetters } from 'vuex'

// Mixins
import { repository, error, stringCase, object } from '@/mixins'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        autocompleteFields() {

            return {
                ocupacao: [
                    { key: 'codigo', searchable: true },
                    { key: 'nome', searchable: true },
                ],
            }
        },
        autocompleteQueryStringParams() {

            return {
                ocupacao: {
                    funcionalidade_id: this.item.id
                }
            }
        },
        validations() {
            return {
                ocupacao: { required: true, },
            }
        },
        fields() {

            return [
                { key: 'descricao', label: 'Descrição', sortable: true, },
                { key: 'actions', label: 'Ações', class: 'col-min text-center', },
            ]
        },
        ocupacoes() {

            return this.item && this.data.model.outros.permissao.find(permissao => permissao.id === this.item.id)
                ? this.data.model.outros.permissao.find(permissao => permissao.id === this.item.id).ocupacoes
                : null
        },
    },
    created() {

        this.repositories = {
            ocupacao: this.getConectaSusRepository('atencaoBasica.parametrizacao')
        }
    },
    data: () => ({
        index: null,
        item: {},
        model: {
            ocupacao: {},
            ocupacoes: [],
        },
    }),
    methods: {
        async validate() {

            return true
        },
        async verificaDuplicidade() {

            if (this.data.model.outros.permissao
                .find(permissao => permissao.id === this.item.id).ocupacoes
                .find(ocupacao => ocupacao.codigo === this.model.ocupacao.codigo)) {

                this.showValidationNotification('A Ocupação já foi inserida.')

                return false
            }

            return true
        },
        open(index, item) {

            this.index = index
            this.item = item

            this.$refs.Modal.show()
        },
        add() {

            this.verificaDuplicidade()
                .then(isValid => {

                    if (!isValid) return

                    this.data.model.outros.permissao
                        .find(permissao => permissao.id === this.item.id).ocupacoes
                        .push(this.model.ocupacao)
                })
                .finally(() => this.limpaFormulario())

        },
        limpaFormulario() {

            this.model.ocupacao = {}

            this.$nextTick()
                .then(() => this.$refs.FormPermissaoOcupacao.resetValidator())
        },
        handleDestroy(index) {

            const destroy = async () => this.data.model.outros.permissao
                .find(permissao => permissao.id === this.item.id).ocupacoes
                .splice(index, 1)

            this.showDeleteConfirmation(
                'Deseja realmente excluir a Ocupação?',
                destroy,
                this.handleError
            )
        },
        handleCancel() {

            this.$refs.Modal.hide()
        },
    },
    mixins: [ repository, error, stringCase, object ],
    props: {
        data: { type: Object, required: true, },
    }
}
</script>